import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, Trophy, Check, Lock, Mail, Shield, RefreshCw } from 'lucide-react';
const packs = [{
  id: 'inicial',
  icon: <Zap className="text-blue-600" data-id="element-128" />,
  title: 'PACK QUÍMICA INICIAL — 5 CUADERNILLOS',
  subtitle: 'El más elegido',
  isMostPopular: true,
  features: ['5 cuadernillos completos de 1° a 5° año', 'Actividades secuenciadas', 'Rúbricas integradas', 'Experiencias y fichas de registro', '6 bonos estratégicos incluidos'],
  oldPrice: '$29.900',
  price: '$19.990 ARS',
  cta: 'Sí, quiero mi MegaPack',
  url: 'https://checkout.guiadigital360.online/cart/43928145002565:1'
}, {
  id: 'vip',
  icon: <Trophy className="text-blue-600" data-id="element-129" />,
  title: 'PACK QUÍMICA VIP',
  subtitle: 'Más resuelto, más actualizado',
  savings: 'AHORRÁS $14.910 ARS',
  features: ['Incluye todo lo del Pack Inicial, más:', '✅ Cuadernillos adaptados al diseño curricular de la Provincia de Buenos Aires', '✅ Actualizaciones del Drive de por vida', '✅ Material complementario para seguir mejorando tu planificación'],
  oldPrice: '$39.900',
  price: '$24.990 ARS',
  cta: 'Sí, quiero mi MegaPack',
  url: 'https://checkout.guiadigital360.online/cart/44552070725701:1'
}, {
  id: 'combo',
  icon: <Trophy className="text-blue-600" data-id="element-130" />,
  title: 'PACK COMPLETO QUÍMICA + FÍSICA COMPLETO.',
  subtitle: 'Todo listo y armado',
  savings: 'AHORRÁS MÁS Y RESOLVÉS DOS ÁREAS DE UNA VEZ',
  features: ['Llevate el sistema completo para trabajar ambas materias con una sola compra.'],
  oldPrice: '$39.980',
  price: '$32.990 ARS',
  cta: 'Sí, quiero mi MegaPack',
  url: 'https://checkout.guiadigital360.online/cart/44770181808197:1'
}];
export function Pricing() {
  const [selectedPack, setSelectedPack] = useState('vip');
  const handlePurchase = () => {
    const pack = packs.find(p => p.id === selectedPack);
    // Track InitiateCheckout event
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: pack?.title,
        content_ids: [pack?.id],
        content_type: 'product',
        value: pack?.price.replace(/[^0-9]/g, ''),
        currency: 'ARS'
      });
    }
    if (pack?.url) window.location.href = pack.url;
  };
  return <section id="pricing" className="py-2 md:py-12 px-4 max-w-4xl mx-auto min-h-[100dvh] flex flex-col justify-center" data-id="element-131">
      <div className="text-center mb-2 md:mb-10" data-id="element-132">
        <h2 className="text-xl md:text-5xl font-black text-slate-900 mb-1 md:mb-4" data-id="element-133">
          Elegí tu <span className="text-blue-600" data-id="element-134">MegaPack</span> Química en
          Acción:
        </h2>
        <p className="text-slate-600 font-bold text-[10px] md:text-lg" data-id="element-135">
          Todas las opciones incluyen los 6 Bonos Estratégicos
        </p>
      </div>

      <div className="space-y-2 md:space-y-4 mb-4 md:mb-8" data-id="element-136">
        {packs.map(pack => <motion.div key={pack.id} onClick={() => setSelectedPack(pack.id)} className={`cursor-pointer p-3 md:p-8 rounded-2xl md:rounded-3xl border-2 transition-all relative overflow-hidden ${selectedPack === pack.id ? 'border-blue-600 bg-white shadow-xl shadow-blue-900/10' : 'border-blue-100 bg-white/50 hover:border-blue-300'}`} data-id="element-137">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-138">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center mt-0.5 md:mt-1 shrink-0 ${selectedPack === pack.id ? 'border-blue-600' : 'border-slate-300'}`} data-id="element-139">
                {selectedPack === pack.id && <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-blue-600 rounded-full" data-id="element-140" />}
              </div>
              <div className="flex-1" data-id="element-141">
                <div className="flex flex-wrap gap-1 md:gap-2 mb-1 md:mb-3" data-id="element-142">
                  {pack.isMostPopular && <span className="bg-blue-600 text-white text-[7px] md:text-[10px] font-black px-1.5 py-0.5 rounded-full uppercase tracking-widest" data-id="element-143">
                      MÁS ELEGIDO
                    </span>}
                  {pack.savings && <span className="bg-green-500 text-white text-[7px] md:text-[10px] font-black px-1.5 py-0.5 rounded-full uppercase tracking-widest" data-id="element-144">
                      {pack.savings}
                    </span>}
                </div>
                <div className="flex items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-145">
                  <span className="scale-75 md:scale-100 origin-left" data-id="element-146">
                    {pack.icon}
                  </span>
                  <h3 className="font-black text-slate-900 text-[11px] md:text-xl uppercase leading-tight" data-id="element-147">
                    {pack.title}
                  </h3>
                </div>
                <p className="text-slate-500 font-bold text-[9px] md:text-sm mb-1 md:mb-4" data-id="element-148">
                  {pack.subtitle}
                </p>
                {selectedPack === pack.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} className="space-y-1 md:space-y-2 mb-2 md:mb-6" data-id="element-149">
                    {pack.features.map((f, i) => <div key={i} className="flex items-start gap-1.5 text-[9px] md:text-base text-slate-700 font-medium leading-tight" data-id="element-150">
                        {!f.startsWith('✅') && <Check size={12} className="text-blue-600 shrink-0 mt-0.5 md:w-4 md:h-4" data-id="element-151" />}
                        <span data-id="element-152">{f}</span>
                      </div>)}
                  </motion.div>}
                <div className="flex items-baseline gap-2 md:gap-3" data-id="element-153">
                  {pack.oldPrice && <span className="text-slate-400 line-through font-bold text-[10px] md:text-lg" data-id="element-154">
                      {pack.oldPrice}
                    </span>}
                  <span className="text-lg md:text-4xl font-black text-slate-900" data-id="element-155">
                    {pack.price}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>

      <motion.button animate={{
      boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 25px rgba(34,197,94,0.4)', '0 0 15px rgba(34,197,94,0.2)']
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handlePurchase} className="w-full bg-green-600 hover:bg-green-700 text-white font-black text-lg md:text-3xl py-4 md:py-6 rounded-2xl md:rounded-3xl shadow-xl shadow-green-900/20 mb-2 md:mb-4 uppercase tracking-tight" data-id="element-156">
        Sí, quiero el{' '}
        {packs.find(p => p.id === selectedPack)?.title.split('—')[0].replace('.', '').trim()}{' '}
        →
      </motion.button>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 mb-4 md:mb-12 mt-4 md:mt-16" data-id="element-157">
        {[{
        icon: <Lock data-id="element-158" />,
        title: 'Pago Seguro',
        desc: 'Mercado Pago'
      }, {
        icon: <Mail data-id="element-159" />,
        title: 'Acceso Inmediato',
        desc: 'Envío al instante'
      }, {
        icon: <Shield data-id="element-160" />,
        title: 'Garantía 7 Días',
        desc: 'Riesgo cero'
      }, {
        icon: <RefreshCw data-id="element-161" />,
        title: 'Actualizaciones',
        desc: 'Gratis de por vida'
      }].map((badge, i) => <div key={i} className="bg-white p-6 rounded-3xl border border-blue-50 text-center flex flex-col items-center" data-id="element-162">
            <div className="text-blue-600 mb-3" data-id="element-163">{badge.icon}</div>
            <p className="font-black text-slate-900 text-xs md:text-sm mb-1" data-id="element-164">
              {badge.title}
            </p>
            <p className="text-slate-400 text-[10px] md:text-xs font-bold" data-id="element-165">
              {badge.desc}
            </p>
          </div>)}
      </div>

      <div className="bg-white p-8 rounded-[2.5rem] border border-blue-100 flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-166">
        <div className="bg-blue-50 p-4 rounded-2xl text-blue-600" data-id="element-167">
          <Shield size={40} data-id="element-168" />
        </div>
        <div data-id="element-169">
          <h5 className="text-slate-900 font-black text-lg md:text-xl mb-1" data-id="element-170">
            Garantía de satisfacción 7 días
          </h5>
          <p className="text-slate-500 font-medium text-sm md:text-base" data-id="element-171">
            Si no te sirve, te devolvemos el 100% de tu dinero sin preguntas.
          </p>
        </div>
      </div>
    </section>;
}